import { HTTP } from "./http";
import { Store } from "../store/index.js";
import { config } from "../config.js";
const utmSource = config.source[process.env.VUE_APP_BRAND];
const ENDPOINT_WALKING_USER =
  "walking_user?utm_source=" +
  utmSource +
  "&utm_medium=web&utm_campaign=listing";

/* eslint-disable */
export default {
  resetStatesForNewMortgage() {
    Store.commit("mortgageData/CLEAR_ALL");
    Store.commit("mortgageLean/CLEAR_ALL");
  },

  submitWalkingUser(data, uuid = null) {
    uuid = uuid === null ? "" : uuid;

    let preparedData = {
      uuid: uuid,
      data: {
        price: data.price,
        province_id: data.province_id,
        operation_type: data.operation_type,
        mortgage_years: data.mortgage_years,
        occupancy: data.occupancy,
        income: data.income,
        expenses: data.expenses,
        savings: data.savings,
        interest_type: data.interest_type,
        criteria: data.criteria,
        reason_choice: data.reason_choice,
        current_step: data.current_step,
      },
    };
    return new Promise((resolve, reject) => {
      HTTP.post(ENDPOINT_WALKING_USER, preparedData)
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  getProposals(mortgageId) {
    return new Promise((resolve, reject) => {
      HTTP.get("mortgage/" + mortgageId + "/proposals")
        .then(function(response) {
          resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error.response.data);
        });
    });
  },

  createUserByEmailAndGetProposals(data) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        "walking_user/user/create?utm_source=" +
          utmSource +
          "&utm_medium=web&utm_campaign=listing",
        { data: data }
      )
        .then(function(response) {
          resolve(response.data.results);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  createMortgage(data) {
    return new Promise((resolve, reject) => {
      HTTP.post("/v2/widget/create-mortgage", data)
        .then((response) => resolve(response.data.results))
        .catch((error) => reject(error));
    });
  },

  submitAffordMortgage(data) {
    return new Promise((resolve, reject) => {
      HTTP.post("/v2/widget/proposals-viability", data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  },

  requestMortgage(mortgageConditionId, data) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/v2/widget/proposals-viability/${mortgageConditionId}`, data)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
};
